import GiftListContainer from './GiftListContainer';
export default GiftListContainer;
